import { isMobile } from '../base'

export function initCategory() {
    categoriesBannersCategory()
    categoryDescMobileImg()
}

function categoriesBannersCategory() {
    $('footer .categories-banner__wrapper').appendTo($('.content-wrapper'))

    if (isMobile()) {
        $('.categories-banner__wrapper').addClass('container')
    }
}

// Zobrazí nahraný obrázek v mobilním rozlišení a skryje obrázek v desktopu v horním popisu kategorie
function categoryDescMobileImg() {
    if (isMobile()) {
        const mobileImg = $('.category__secondDescription img')

        $('.category-perex img').attr('src', mobileImg.attr('src'))
    }
}
